import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import mkcgLogo from "../assests/logo/logo.png";

/* ─────────────────────────────────────────────
   College Crest
───────────────────────────────────────────── */
const CollegeCrest = ({ size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 4 L92 20 V46 C92 70 74 88 50 96 C26 88 8 70 8 46 V20 Z"
      fill="#FFFFFF"
      stroke="#00274C"
      strokeWidth="2.5"
    />

    <path
      d="M50 10 L86 24 V46 C86 66 71 82 50 90 C29 82 14 66 14 46 V24 Z"
      fill="#F4F7FB"
      stroke="#1A6FB8"
      strokeWidth="1"
    />

    <g
      stroke="#00274C"
      strokeWidth="2.4"
      strokeLinecap="round"
      fill="none"
    >
      <path d="M50 26 V70" />
      <path d="M38 34 C38 34 44 40 50 40 C56 40 62 34 62 34" />
      <path d="M40 52 C40 52 45 47 50 47 C55 47 60 52 60 52" />

      <circle
        cx="50"
        cy="24"
        r="4"
        fill="#F2760C"
        stroke="#00274C"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

/* ─────────────────────────────────────────────
   Instructions
───────────────────────────────────────────── */
const step1Items = [
  "Name",
  "Gender",
  "Date of Birth",
  "Mobile Number",
  "Email ID  (** Must be Unique. Email ID will be authenticated through OTP)",
  "Password  (** Define password to access your profile)",
];

const step2Fields = [
  "Personal Details (as per official records)",
  "Parent/Guardian Information",
  "Reservation Category & Sub-Category",
  "Address Details (Present & Permanent)",
  "Contact Information",
  "Last Qualifying Examination Details",
];

const step2Docs = [
  "ID Proof Document (PDF/JPG up to 200 KB)",
  "Passport-size Photograph (JPG 50–100 KB)",
  "Signature (JPG 20–50 KB)",
];

const notes = [
  "Students who have completed their 1st Step, need to login using their credentials to complete Step 2.",
  "If both steps are completed, the student can view their profile, confirm submission and take a printout for reference.",
  "The student profile will be treated as complete only if both steps are completed.",
];

/* ─────────────────────────────────────────────
   Main Component
───────────────────────────────────────────── */
export default function RegistrationGate({ onProceed }) {
  const [agreed, setAgreed] = useState(false);
  const [shake, setShake] = useState(false);

  const navigate = useNavigate();

  const handleAgree = () => {
    if (!agreed) {
      setShake(true);

      setTimeout(() => {
        setShake(false);
      }, 600);

      return;
    }

    onProceed?.();
  };

  const handleDisagree = () => {
    setAgreed(false);
    navigate("/");
  };

  return (
    <>
      <style>{css}</style>

      <div className="ig-page">

        {/* ───────────────── TOP NAVBAR ───────────────── */}
        <header className="ig-navbar">

          <div className="ig-navbar-left">

            <img
              className="logo-image"
              src={mkcgLogo}
              alt="MKCG Medical College"
            />

            <div className="ig-navbar-titles">

              <h1 className="ig-navbar-title">
                MKCG MEDICAL COLLEGE, BRAHMAPUR, ODISHA, INDIA
              </h1>

              <p className="ig-navbar-subtitle">
                ମହାରାଜା କୃଷ୍ଣଚନ୍ଦ୍ର ଗଜପତି ଭେଷଜ ମହାବିଦ୍ୟାଳୟ, ବ୍ରହ୍ମପୁର, ଓଡ଼ିଶା, ଭାରତ
              </p>

            </div>
          </div>

          <div className="ig-navbar-right">

            <span className="ig-navbar-badge">
              STUDENT INTERFACE
            </span>

            <Link
              to="/"
              className="ig-home-btn"
            >
              Return to Home
            </Link>

          </div>

        </header>

        {/* ───────────────── BODY ───────────────── */}
        <div className="ig-wrap">

          <div className="ig-card">

            {/* ───────────────── LEFT PANEL ───────────────── */}
            <aside className="ig-side">

              <div className="ig-logo-wrapper">

                <img
                  src={mkcgLogo}
                  alt="MKCG Medical College"
                />

              </div>

              <h2 className="ig-side-name">
                M.K.C.G. MEDICAL COLLEGE
              </h2>

              <p className="ig-side-loc">
                BRAHMAPUR, ODISHA, INDIA
              </p>

              <p className="ig-side-odia">
                ମହାରାଜା କୃଷ୍ଣଚନ୍ଦ୍ର ଗଜପତି ଭେଷଜ ମହାବିଦ୍ୟାଳୟ,
                <br />
                ବ୍ରହ୍ମପୁର, ଓଡ଼ିଶା, ଭାରତ
              </p>

              <p className="ig-side-govt">
                (GOVT. OF ODISHA)
              </p>

            </aside>

            {/* ───────────────── RIGHT PANEL ───────────────── */}
            <section className="ig-main">

              <div className="ig-scroll">

                <h3 className="ig-heading">
                  INSTRUCTIONS TO STUDENTS FOR ONLINE REGISTRATION
                </h3>

                <p className="ig-intro">
                  Student Registration Process is a two step approach as mentioned below :
                </p>

                {/* STEP 1 */}
                <h4 className="ig-step-heading">
                  STEP 1 – BASIC DETAILS OF STUDENTS WITH OTP AUTHENTICATION
                </h4>

                <p className="ig-step-desc">
                  Students need to fill the following details :
                </p>

                <ul className="ig-list">

                 {step1Items.map((item, i) => {
                    const parts = item.split("**");

                    return (
                      <li key={i}>
                        {parts[0]}
                        {parts.length > 1 && (
                          <>
                            <span className="ig-red-stars">**</span>
                            {parts[1]}
                          </>
                        )}
                      </li>
                    );
                  })}

                </ul>

                <p className="ig-dash">
                  -- On successful submission of basic details, student login profile is created.
                </p>

                <p className="ig-dash">
                  -- Subsequently Student can login using Email ID and Password.
                </p>

                {/* STEP 2 */}
                <h4 className="ig-step-heading">
                  STEP 2 – UPLOAD OTHER DETAILS AND DOCUMENTS
                </h4>

                <p className="ig-step-desc">
                  Students need to fill the following details :
                </p>

                <ul className="ig-list">

                  {step2Fields.map((item, i) => (
                    <li key={i}>
                      {item}
                    </li>
                  ))}

                </ul>

                <p
                  className="ig-step-desc"
                  style={{ marginTop: "0.9rem" }}
                >
                  Required scanned documents :
                </p>

                <ul className="ig-list">

                  {step2Docs.map((item, i) => (
                    <li key={i}>
                      {item}
                    </li>
                  ))}

                </ul>

                {/* NOTES */}
                <div className="ig-notes">

                  {notes.map((note, i) => (
                    <p
                      key={i}
                      className="ig-note"
                    >
                      <span className="ig-note-star">
                        **
                      </span>{" "}
                      {note}
                    </p>
                  ))}

                </div>

                <p className="ig-back-note">

                  Already registered?{" "}

                  {/* <Link
                    to="/StudentLogin"
                    className="ig-back-link"
                  >
                    Login here
                  </Link> */}

                    <Link
                      to="/StudentLogin"
                      className="ig-back-link"
                    >
                      Login here
                    </Link>                  

                </p>

              </div>

              {/* ───────────────── AGREE BOX ───────────────── */}
              <div
                className={`ig-agree-box${
                  shake ? " ig-shake" : ""
                }`}
              >

                <label className="ig-agree-label">

                  <input
                    type="checkbox"
                    className="ig-checkbox"
                    checked={agreed}
                    onChange={(e) =>
                      setAgreed(e.target.checked)
                    }
                  />

                  <span>
                    I have read the instructions and agree to follow them.
                  </span>

                </label>

                {!agreed && shake && (
                  <p className="ig-warn">
                    ⚠ Please check the agreement box to proceed.
                  </p>
                )}

                <div className="ig-btn-row">

                  <button
                    type="button"
                    className={`ig-btn ig-btn-agree${
                      agreed
                        ? " ig-btn-agree-active"
                        : ""
                    }`}
                    onClick={handleAgree}
                  >
                    Agree
                  </button>

                  <button
                    type="button"
                    className="ig-btn ig-btn-disagree"
                    onClick={handleDisagree}
                  >
                    Disagree
                  </button>

                </div>

              </div>

            </section>

          </div>

        </div>

      </div>
    </>
  );
}

/* ═══════════════════════════════════════════════
   CSS
   Typography is kept consistent throughout
   the entire React page.
═══════════════════════════════════════════════ */

const css = `

/* Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600;700;800&family=Noto+Sans+Odia:wght@400;500;600&display=swap');


/* ═══════════════════════════════════════════════
   GLOBAL
═══════════════════════════════════════════════ */

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

:root {

  --navy: #0B2447;
  --navy-deep: #071A33;

  --blue-mid: #12376B;
  --blue-light: #2E6FCE;

  --orange: #F2760C;

  --panel-border: #E1E7F0;

  --text: #1D2A3A;
  --text-muted: #4A5A70;

  --error: #C0392B;

  --pink-bg: #FCE9EA;
  --pink-border: #F3C6C9;

  --green: #59B37D;
  --green-dark: #3E9563;
}


/* ═══════════════════════════════════════════════
   IMPORTANT TYPOGRAPHY
═══════════════════════════════════════════════ */

.ig-page,
.ig-page button,
.ig-page input,
.ig-page select,
.ig-page textarea {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

}


/* Main normal text */
.ig-page {

  min-height: 100vh;

  font-size: 0.9rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text);

  background: #EEF2F7;

}


/* ═══════════════════════════════════════════════
   TOP NAVBAR
═══════════════════════════════════════════════ */

.ig-navbar {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 1rem;

  background: #023c77ff;

  color: #fff;

  padding: 0.65rem 1.5rem;

  box-shadow:
    0 2px 10px rgba(0, 0, 0, 0.25);

}


.ig-navbar-left {

  display: flex;

  align-items: center;

  gap: 0.85rem;

}


.logo-image {

  height: 55px;

  width: auto;

  object-fit: contain;

}


.ig-navbar-titles {

  line-height: 1.25;

}


.ig-navbar-title {

  margin: 0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 16px;

  font-weight: 600;

  color: #fff;

  line-height: 1.25;

  letter-spacing: 0.01em;

}


.ig-navbar-subtitle {

  margin: 2px 0 0;

  padding: 0;

  font-family:
    'Noto Sans Odia',
    sans-serif;
    font-size:14px;

  font-weight: 500;

  color:fff;

  line-height: 1.5;

}


.ig-navbar-right {

  display: flex;

  align-items: center;

  gap: 1rem;

}


.ig-navbar-badge {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.78rem;

  font-weight: 700;

  letter-spacing: 0.05em;

  color: #E8EEF7;

}


.ig-home-btn {

  display: inline-block;

  background: #fff;

  color: #023c77ff;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.82rem;

  font-weight: 700;

  line-height: 1.5;

  padding: 7px 16px;

  border-radius: 6px;

  text-decoration: none;

  transition:
    background 0.2s ease;

}


.ig-home-btn:hover {

  background: #DCE6F5;

  color: rgb(17, 88, 158);

}


/* ═══════════════════════════════════════════════
   BODY
═══════════════════════════════════════════════ */

.ig-wrap {

  max-width: 1100px;

  padding: 0 1.25rem;

  margin: auto;

  padding-top: 10px;

}


.ig-card {

  display: grid;

  grid-template-columns: 320px 1fr;

  background: #fff;

  border-radius: 10px;

  overflow: hidden;

  box-shadow:
    0 6px 24px rgba(11, 36, 71, 0.15);

  min-height: 540px;

}


/* ═══════════════════════════════════════════════
   LEFT PANEL
═══════════════════════════════════════════════ */

.ig-side {

  background:
    linear-gradient(
      160deg,
      var(--blue-mid) 0%,
      var(--blue-light) 100%
    );

  color: #fff;

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;

  padding: 2.5rem 1.75rem;

}


.ig-logo-wrapper {

  display: flex;

  justify-content: center;

  align-items: center;

  margin-bottom: 1.5rem;

}


.ig-navbar-crest {

  width: 132px;

  height: 132px;

  object-fit: contain;

  background: #fff;

  border-radius: 50%;

  padding: 8px;

  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.2);

}


.ig-side-name {

  margin: 0 0 0.35rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 1.15rem;

  font-weight: 800;

  line-height: 1.3;

  letter-spacing: 0.02em;

  color: #fff;

}


.ig-side-loc {

  margin: 0 0 1.1rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.95rem;

  font-weight: 600;

  line-height: 1.5;

  color: #DCE9FF;

}


.ig-side-odia {

  margin: 0 0 1.6rem;

  padding: 0;

  font-family:
    'Noto Sans Odia',
    sans-serif;

  font-size: 0.92rem;

  font-weight: 400;

  line-height: 1.7;

  color: #EAF1FF;

}

.ig-red-stars {
  color: #C0392B;
  font-weight: 700;
}


.ig-side-govt {

  margin: 0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 1rem;

  font-weight: 700;

  line-height: 1.5;

  letter-spacing: 0.03em;

  color: #fff;

}


/* ═══════════════════════════════════════════════
   RIGHT PANEL
═══════════════════════════════════════════════ */

.ig-main {

  display: flex;

  flex-direction: column;

  min-height: 0;

}


.ig-scroll {

  padding:
    1.75rem
    2rem
    1.5rem;

  overflow-y: auto;

  max-height: 420px;

}


/* ═══════════════════════════════════════════════
   MAIN HEADING
═══════════════════════════════════════════════ */

.ig-heading {

  margin:
    0
    0
    1.1rem;

  padding: 0;

  text-align: center;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 1.05rem;

  font-weight: 700;

  line-height: 1.5;

  color: var(--navy);

  text-decoration: underline;

}


/* ═══════════════════════════════════════════════
   NORMAL CONTENT
═══════════════════════════════════════════════ */

.ig-intro {

  margin:
    0
    0
    1rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.92rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text);

}


.ig-step-heading {

  margin:
    1.1rem
    0
    0.6rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.95rem;

  font-weight: 700;

  line-height: 1.5;

  color: var(--navy);

  text-decoration: underline;

}


.ig-step-desc {

  margin:
    0
    0
    0.5rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.9rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text);

}


/* ═══════════════════════════════════════════════
   LIST
═══════════════════════════════════════════════ */

.ig-list {

  list-style: disc;

  padding-left: 1.4rem;

  margin:
    0
    0
    0.4rem;

  display: flex;

  flex-direction: column;

  gap: 0.3rem;

}


.ig-list li {

  margin: 0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.9rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text);

}


/* ═══════════════════════════════════════════════
   DASH TEXT
═══════════════════════════════════════════════ */

.ig-dash {

  margin:
    0.15rem
    0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.88rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text-muted);

}


/* ═══════════════════════════════════════════════
   NOTES
═══════════════════════════════════════════════ */

.ig-notes {

  margin-top: 1.1rem;

  padding-top: 0.9rem;

  border-top:
    1px dashed
    var(--panel-border);

  display: flex;

  flex-direction: column;

  gap: 0.4rem;

}


.ig-note {

  margin: 0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.85rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text-muted);

}


.ig-note-star {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  color: #c0392b;

  font-weight: 700;

}


/* ═══════════════════════════════════════════════
   LOGIN LINK
═══════════════════════════════════════════════ */

.ig-back-note {

  margin:
    1.3rem
    0
    0;

  padding: 0;

  text-align: center;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.85rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text-muted);

}


.ig-back-link {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

 color: #c0392b;

  font-size: inherit;

  font-weight: 700;

  text-decoration: none;
  animation: ig-login-blink 1.2s ease-in-out infinite;

}
.ig-back-link:hover {
  text-decoration: underline;
  animation: none;
}

/* Blinking animation */
@keyframes ig-login-blink {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.25;
  }
}



/* ═══════════════════════════════════════════════
   AGREE BOX
═══════════════════════════════════════════════ */

.ig-agree-box {

  margin:
    0
    2rem
    1.75rem;

  background: var(--pink-bg);

  border:
    1px solid
    var(--pink-border);

  border-radius: 10px;

  padding:
    1rem
    1.25rem
    1.15rem;

}


.ig-agree-label {

  display: flex;

  align-items: center;

  gap: 0.65rem;

  margin:
    0
    0
    0.85rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.9rem;

  font-weight: 500;

  line-height: 1.5;

  color: var(--text);

  cursor: pointer;

}


.ig-agree-label span {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.9rem;

  font-weight: 500;

  line-height: 1.5;

  color: var(--text);

}


.ig-checkbox {

  width: 17px;

  height: 17px;

  margin: 0;

  cursor: pointer;

}


/* ═══════════════════════════════════════════════
   WARNING
═══════════════════════════════════════════════ */

.ig-warn {

  margin:
    -0.4rem
    0
    0.7rem;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.8rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--error);

}


/* ═══════════════════════════════════════════════
   BUTTONS
═══════════════════════════════════════════════ */

.ig-btn-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.65rem;
}


.ig-btn {
  width: auto;
  flex: 0 0 auto;
  min-width: 90px;
  padding: 7px 16px;
  margin: 0;

  font-family: 'Noto Sans', Arial, sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  line-height: 1.4;

  border: none;
  border-radius: 6px;
  cursor: pointer;

  transition:
    filter 0.2s,
    transform 0.15s;
}

.ig-btn:hover {

  filter: brightness(1.06);

}


.ig-btn:active {

  transform: translateY(1px);

}


.ig-btn-agree {

  background: var(--green);

  color: #fff;

}


.ig-btn-agree-active {

  background: var(--green-dark);

  color: #fff;

  box-shadow:
    0 3px 12px
    rgba(62, 149, 99, 0.4);

}


.ig-btn-disagree {

  background: var(--error);

  color: #fff;

}


/* ═══════════════════════════════════════════════
   SHAKE ANIMATION
═══════════════════════════════════════════════ */

@keyframes ig-shake-anim {

  0%,
  100% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-6px);
  }

  40% {
    transform: translateX(6px);
  }

  60% {
    transform: translateX(-4px);
  }

  80% {
    transform: translateX(4px);
  }

}


.ig-shake {

  animation:
    ig-shake-anim
    0.5s
    ease;

}


/* ═══════════════════════════════════════════════
   RESPONSIVE
═══════════════════════════════════════════════ */

@media (max-width: 860px) {

  .ig-card {

    grid-template-columns: 1fr;

  }

  .ig-side {

    padding:
      1.75rem
      1.5rem;

  }

  .ig-navbar {

    flex-direction: column;

    align-items: flex-start;

    gap: 0.6rem;

  }

  .ig-navbar-right {

    align-self: flex-end;

  }

}


@media (max-width: 600px) {

  .ig-navbar-title {

    font-size: 0.9rem;

  }



  .ig-agree-box {

    margin:
      0
      1.25rem
      1.25rem;

  }

}

`;